import { defineMessages } from 'react-intl';

export default defineMessages({
  backString: {
    id: 'back',
    description: 'back',
    defaultMessage: 'Back',
  },
});
